/**
 * JLPT Placement Test Questions - N5, N4, N3
 * Each level has 5 questions
 */

// ═══════════════ N5 Questions ═══════════════
// もんだい１: Kanji to Hiragana (questions 1-5)
// もんだい２: Hiragana to Kanji (questions 6-10)
export const n5Questions = [
  // もんだい１
  {
    id: 1,
    level: 'N5',
    question: 'あしたは　雨です。',
    instruction: '＿＿＿＿＿の　ことばは　ひらがなで　どう　かきますか。',
    options: [
      'A. くもり',
      'B. ゆき',
      'C. あめ',
      'D. はれ',
    ],
    correctAnswer: 2, // C. あめ
  },
  {
    id: 2,
    level: 'N5',
    question: '学校まで、バスで　いきます。',
    instruction: '＿＿＿＿＿の　ことばは　ひらがなで　どう　かきますか。',
    options: [
      'A. がっこ',
      'B. がっこう',
      'C. がくこう',
      'D. かっこう',
    ],
    correctAnswer: 1, // B. がっこう
  },
  {
    id: 3,
    level: 'N5',
    question: 'この　ほんは　かんじが　多いです。',
    instruction: '＿＿＿＿＿の　ことばは　ひらがなで　どう　かきますか。',
    options: [
      'A. おい',
      'B. おおきい',
      'C. おおい',
      'D. おうい',
    ],
    correctAnswer: 2, // C. おおい
  },
  {
    id: 4,
    level: 'N5',
    question: 'ノートに　なまえを　かたかなで　書きました。',
    instruction: '＿＿＿＿＿の　ことばは　ひらがなで　どう　かきますか。',
    options: [
      'A. がきました',
      'B. かっきました',
      'C. しょきました',
      'D. かきました',
    ],
    correctAnswer: 3, // D. かきました
  },
  {
    id: 5,
    level: 'N5',
    question: '出口は　あちらです。',
    instruction: '＿＿＿＿＿の　ことばは　ひらがなで　どう　かきますか。',
    options: [
      'A. でぐち',
      'B. てくち',
      'C. でくち',
      'D. しゅっくち',
    ],
    correctAnswer: 0, // A. でぐち
  },
  // もんだい２
  {
    id: 6,
    level: 'N5',
    question: 'コーヒー　を　のみました。',
    instruction: '＿＿＿＿＿の　ことばは　どう　かきますか。',
    options: [
      'A. 飾みました',
      'B. 餃みました',
      'C. 飲みました',
      'D. 飯みました',
    ],
    correctAnswer: 2, // C. 飲みました
  },
  {
    id: 7,
    level: 'N5',
    question: 'あたらしい　くるまを　かいました。',
    instruction: '＿＿＿＿＿の　ことばは　どう　かきますか。',
    options: [
      'A. 軍',
      'B. 車',
      'C. 早',
      'D. 卓',
    ],
    correctAnswer: 1, // B. 車
  },
  {
    id: 8,
    level: 'N5',
    question: 'この　ぼうしは　１０００えんです。',
    instruction: '＿＿＿＿＿の　ことばは　どう　かきますか。',
    options: [
      'A. １０００円',
      'B. １０００冊',
      'C. １０００用',
      'D. １０００内',
    ],
    correctAnswer: 0, // A. １０００円
  },
  {
    id: 9,
    level: 'N5',
    question: 'けさ　しゃわーを　あびました。',
    instruction: '＿＿＿＿＿の　ことばは　どう　かきますか。',
    options: [
      'A. 洗びました',
      'B. 浴びました',
      'C. 泳びました',
      'D. 湯びました',
    ],
    correctAnswer: 1, // B. 浴びました
  },
  {
    id: 10,
    level: 'N5',
    question: 'まいにち　しんぶんを　よみます。',
    instruction: '＿＿＿＿＿の　ことばは　どう　かきますか。',
    options: [
      'A. 新文',
      'B. 親聞',
      'C. 新聞',
      'D. 親文',
    ],
    correctAnswer: 2, // C. 新聞
  },
];

// ═══════════════ N4 Questions ═══════════════
export const n4Questions = [
  {
    id: 1,
    level: 'N4',
    question: '昨日、友達と映画を見に行きました。',
    instruction: '＿＿＿＿＿の　ことばは　ひらがなで　どう　かきますか。',
    options: [
      'A. えが',
      'B. ええが',
      'C. えいが',
      'D. えんが',
    ],
    correctAnswer: 2, // C. えいが
  },
  {
    id: 2,
    level: 'N4',
    question: '新しい携帯電話を買いました。',
    instruction: '＿＿＿＿＿の　ことばは　ひらがなで　どう　かきますか。',
    options: [
      'A. けいたいでんわ',
      'B. けたいでんわ',
      'C. けいたいてんわ',
      'D. けいだいでんわ',
    ],
    correctAnswer: 0, // A. けいたいでんわ
  },
  {
    id: 3,
    level: 'N4',
    question: '図書館で勉強します。',
    instruction: '＿＿＿＿＿の　ことばは　ひらがなで　どう　かきますか。',
    options: [
      'A. べんきょう',
      'B. べんきょ',
      'C. ぶんきょう',
      'D. ぶんきょ',
    ],
    correctAnswer: 0, // A. べんきょう
  },
  {
    id: 4,
    level: 'N4',
    question: 'この料理は簡単に作れます。',
    instruction: '＿＿＿＿＿の　ことばは　ひらがなで　どう　かきますか。',
    options: [
      'A. りょり',
      'B. りょうり',
      'C. りようり',
      'D. りゅうり',
    ],
    correctAnswer: 1, // B. りょうり
  },
  {
    id: 5,
    level: 'N4',
    question: '駅の近くに住んでいます。',
    instruction: '＿＿＿＿＿の　ことばは　ひらがなで　どう　かきますか。',
    options: [
      'A. すで',
      'B. すんで',
      'C. しんで',
      'D. そんで',
    ],
    correctAnswer: 1, // B. すんで
  },
];

// ═══════════════ N3 Questions ═══════════════
export const n3Questions = [
  // 問題1: Reading (questions 1-5)
  {
    id: 1,
    level: 'N3',
    question: 'このビルの裏に小さなレストランがあります。',
    instruction: '＿＿＿のことばの読み方として最もよいものを、1・2・3・4から一つ えらびなさい。',
    options: [
      '1. そば',
      '2. よこ',
      '3. かげ',
      '4. うら',
    ],
    correctAnswer: 3, // 4. うら
  },
  {
    id: 2,
    level: 'N3',
    question: 'それではゆっくり呼吸をしてください。',
    instruction: '＿＿＿のことばの読み方として最もよいものを、1・2・3・4から一つ えらびなさい。',
    options: [
      '1. こきゅう',
      '2. こきゅう',
      '3. よぎゅう',
      '4. よきゅう',
    ],
    correctAnswer: 0, // 1. こきゅう
  },
  {
    id: 3,
    level: 'N3',
    question: 'あの少年の悲しそうな顔が忘れられない。',
    instruction: '＿＿＿のことばの読み方として最もよいものを、1・2・3・4から一つ えらびなさい。',
    options: [
      '1. やさしそう',
      '2. かなりそう',
      '3. きびしそう',
      '4. さびしそう',
    ],
    correctAnswer: 3, // 4. さびしそう
  },
  {
    id: 4,
    level: 'N3',
    question: 'このあたりに駐車しましょう。',
    instruction: '＿＿＿のことばの読み方として最もよいものを、1・2・3・4から一つ えらびなさい。',
    options: [
      '1. しゅしゃ',
      '2. しゅうしゃ',
      '3. ちゅしゃ',
      '4. ちゅうしゃ',
    ],
    correctAnswer: 3, // 4. ちゅうしゃ
  },
  {
    id: 5,
    level: 'N3',
    question: 'もう逃げてしまったようだ。',
    instruction: '＿＿＿のことばの読み方として最もよいものを、1・2・3・4から一つ えらびなさい。',
    options: [
      '1. にげて',
      '2. なげて',
      '3. こげて',
      '4. あげて',
    ],
    correctAnswer: 0, // 1. にげて
  },
  // 問題6: Grammar (questions 6-10)
  {
    id: 6,
    level: 'N3',
    question: '両親に買ってもらった着物(　　　)大学の卒業式に出席した。',
    instruction: '次の文の(　　　)に入れるのに最もよいものを、1・2・3・4から一つ えらびなさい。',
    options: [
      '1. を',
      '2. が',
      '3. で',
      '4. に',
    ],
    correctAnswer: 2, // 3. で
  },
  {
    id: 7,
    level: 'N3',
    question: '本を読んでいたら(　　　)5時間も経ってしまった。',
    instruction: '次の文の(　　　)に入れるのに最もよいものを、1・2・3・4から一つ えらびなさい。',
    options: [
      '1. そろそろ',
      '2. だんだん',
      '3. ようやく',
      '4. いつのまにか',
    ],
    correctAnswer: 3, // 4. いつのまにか
  },
  {
    id: 8,
    level: 'N3',
    question: '私に(　　　)今一番大切なものは飼っている犬です。',
    instruction: '次の文の(　　　)に入れるのに最もよいものを、1・2・3・4から一つ えらびなさい。',
    options: [
      '1. 対して',
      '2. 比べて',
      '3. おいて',
      '4. とって',
    ],
    correctAnswer: 3, // 4. とって
  },
  {
    id: 9,
    level: 'N3',
    question: 'A「部長の田中とお会いになるのは今日が初めてですか。」B「はい。山下課長(　　　)お目にかかったことがございませんので。」',
    instruction: '次の文の(　　　)に入れるのに最もよいものを、1・2・3・4から一つ えらびなさい。',
    options: [
      '1. にだけ',
      '2. にしか',
      '3. でしか',
      '4. でだけ',
    ],
    correctAnswer: 1, // 2. にしか
  },
  {
    id: 10,
    level: 'N3',
    question: 'この図書館は入り口の近くに、返す本を入れるためのブックポストがあり、図書館が閉まっている(　　　)、本を返すことができます。',
    instruction: '次の文の(　　　)に入れるのに最もよいものを、1・2・3・4から一つ えらびなさい。',
    options: [
      '1. ときでも',
      '2. ままで',
      '3. 間だから',
      '4. ところなら',
    ],
    correctAnswer: 0, // 1. ときでも
  },
];

/**
 * Get questions based on selected JLPT level
 */
export function getQuestionsByLevel(level) {
  switch (level) {
    case 'N5':
      return n5Questions;
    case 'N4':
      return n4Questions;
    case 'N3':
      return n3Questions;
    default:
      return n5Questions;
  }
}

/**
 * Calculate JLPT level recommendation based on quiz score
 */
export function getLevelRecommendation(level, score) {
  // N5 and N3 have 10 questions, N4 has 5 questions
  const total = (level === 'N5' || level === 'N3') ? 10 : 5;
  const percentage = (score / total) * 100;

  // Base recommendations by level and score
  if (level === 'N5') {
    if (score >= 8) {
      return {
        status: 'excellent',
        color: 'teal',
        message: 'Xuất sắc! Bạn đã nắm vững N5.',
        recommendation: 'Bạn hoàn toàn sẵn sàng để bắt đầu với N4. Lộ trình N4 sẽ giúp bạn phát triển vốn từ và ngữ pháp phức tạp hơn.',
        nextLevel: 'N4',
      };
    } else if (score >= 6) {
      return {
        status: 'good',
        color: 'yellow',
        message: 'Khá tốt! Bạn có nền tảng N5.',
        recommendation: 'Bạn có thể ôn lại một số điểm còn yếu ở N5, sau đó bắt đầu N4. Annie sẽ giúp bạn củng cố và tiến bộ nhanh chóng.',
        nextLevel: 'N4',
      };
    } else {
      return {
        status: 'beginner',
        color: 'rose',
        message: 'Đây là lúc tốt để bắt đầu!',
        recommendation: 'Bạn đang ở giai đoạn xây dựng nền tảng. Lộ trình N5 tại Annie Class sẽ giúp bạn xây dựng nền móng vững chắc với phương pháp tự nhiên và hiệu quả.',
        nextLevel: 'N5',
      };
    }
  }

  if (level === 'N4') {
    if (score >= 4) {
      return {
        status: 'excellent',
        color: 'teal',
        message: 'Xuất sắc! Bạn đã nắm vững N4.',
        recommendation: 'Bạn sẵn sàng cho N3 — cấp độ trung cấp đủ để làm việc trong môi trường Nhật ngữ cơ bản.',
        nextLevel: 'N3',
      };
    } else if (score >= 3) {
      return {
        status: 'good',
        color: 'yellow',
        message: 'Khá tốt! Bạn có nền tảng N4.',
        recommendation: 'Với một chút củng cố, bạn hoàn toàn có thể chinh phục N3. Annie sẽ giúp bạn lấp đầy những khoảng trống còn thiếu.',
        nextLevel: 'N3',
      };
    } else {
      return {
        status: 'needs-review',
        color: 'rose',
        message: 'Cần ôn lại N4 để tiến xa hơn.',
        recommendation: 'Bạn nên củng cố lại N4 trước khi chuyển sang N3. Lộ trình cá nhân hóa sẽ giúp bạn tiến nhanh hơn rất nhiều.',
        nextLevel: 'N4',
      };
    }
  }

  if (level === 'N3') {
    if (score >= 8) {
      return {
        status: 'excellent',
        color: 'teal',
        message: 'Xuất sắc! Bạn có trình độ N3 tốt.',
        recommendation: 'Bạn đã có năng lực giao tiếp khá tốt. Tiếp tục với N2 để nâng cao khả năng làm việc chuyên nghiệp trong môi trường Nhật ngữ.',
        nextLevel: 'N2',
      };
    } else if (score >= 6) {
      return {
        status: 'good',
        color: 'yellow',
        message: 'Khá tốt! Bạn có nền tảng N3.',
        recommendation: 'Bạn có thể tiếp tục củng cố N3 hoặc bắt đầu thử thách với N2. Annie sẽ tư vấn lộ trình phù hợp nhất.',
        nextLevel: 'N3',
      };
    } else {
      return {
        status: 'needs-review',
        color: 'rose',
        message: 'Cần ôn lại N3 để tiến xa hơn.',
        recommendation: 'Hãy củng cố lại N3 để đạt nền tảng vững chắc trước khi tiến lên N2. Lộ trình cá nhân hóa sẽ giúp bạn hiệu quả hơn.',
        nextLevel: 'N3',
      };
    }
  }

  // Default fallback
  return {
    status: 'beginner',
    color: 'rose',
    message: 'Bắt đầu hành trình tiếng Nhật!',
    recommendation: 'Annie sẽ giúp bạn xây dựng nền tảng vững chắc từ đầu.',
    nextLevel: level,
  };
}
